import { moeda, TAXA_CARTAO, valorNoCartao } from '../lib/api.ts';

/**
 * Aviso da taxa da maquininha. Calculado a partir do valor configurado no
 * painel em vez de um total fixo no texto: se o valor mudar, o valor no
 * cartão acompanha sem ninguém lembrar de reescrever o aviso.
 */
export function AvisoTaxaCartao({ valor }: { valor: string | number }) {
  return (
    <p>
      Pagamentos feitos na máquina, no <strong>débito ou no crédito</strong>, têm taxa de{' '}
      {Math.round(TAXA_CARTAO * 100)}%: nesse caso o acampamento custa{' '}
      <strong>{moeda(valorNoCartao(valor))}</strong>. No Pix e em dinheiro o valor é{' '}
      {moeda(valor)}.
    </p>
  );
}
